export type ClassificationType =
  | "malicious"
  | "suspicious"
  | "goodware"
  | "unknown";
